import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Privacy Policy for VV Trips App</h1>
      <p style={styles.date}>Last Updated: [March 2025]</p>

      <p>
        Welcome to <strong>VV Trips App</strong> ("we," "our," "us"). Your
        privacy is important to us, and we are committed to protecting the
        personal information you share with us. This Privacy Policy explains how
        we collect, use, disclose, and safeguard your information when you use
        our <strong>VV Trips App</strong> (the "App") on Android and iOS.
      </p>

      <p>
        By using our App, you agree to the terms outlined in this Privacy
        Policy. If you do not agree with this policy, please do not use the App.
      </p>

      <h2 style={styles.subHeading}>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Personal Information:</strong> Name, email, phone, profile
          details, payment details.
        </li>
        <li>
          <strong>Device & Log Data:</strong> IP address, device model, OS, app
          version, logs.
        </li>
        <li>
          <strong>Location Information:</strong> Location data (if permitted).
        </li>
        <li>
          <strong>Social Media Data:</strong> Google, Facebook, or Apple login
          details.
        </li>
        <li>
          <strong>User-Generated Content:</strong> Photos, videos, comments,
          reviews.
        </li>
      </ul>

      <h2 style={styles.subHeading}>2. How We Use Your Information</h2>
      <ul>
        <li>Provide and improve the App’s functionality.</li>
        <li>Facilitate trip planning and interactions.</li>
        <li>Send notifications, trip updates, and promotions.</li>
        <li>Ensure security and prevent fraud.</li>
      </ul>

      <h2 style={styles.subHeading}>3. How We Share Your Information</h2>
      <p>We do not sell or rent personal data but may share it with:</p>
      <ul>
        <li>Service providers (e.g., payments, analytics).</li>
        <li>Other users (if you share trip details).</li>
        <li>Legal authorities (if required).</li>
        <li>Third-party partners (push notifications, analytics).</li>
      </ul>

      <h2 style={styles.subHeading}>4. Push Notifications & Deep Linking</h2>
      <p>
        We send push notifications for trip updates. You can manage notification
        preferences in your device settings.
      </p>

      <h2 style={styles.subHeading}>5. Security Measures</h2>
      <ul>
        <li>Encrypted storage for sensitive data.</li>
        <li>Secure authentication via Amazon Cognito.</li>
        <li>Regular security audits.</li>
      </ul>

      <h2 style={styles.subHeading}>6. Data Retention</h2>
      <p>
        We retain data as long as your account is active. You can request
        account deletion.
      </p>

      <h2 style={styles.subHeading}>7. Your Rights & Choices</h2>
      <ul>
        <li>Access, update, or delete your personal information.</li>
        <li>Opt out of promotional emails and notifications.</li>
        <li>Disable location tracking in your device settings.</li>
      </ul>

      <h2 style={styles.subHeading}>8. Third-Party Services</h2>
      <p>
        Our App may link to third-party services like Google Maps, AWS Amplify,
        FCM, and APN. We are not responsible for their privacy policies.
      </p>

      <h2 style={styles.subHeading}>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this policy periodically. Major changes will be notified
        via email or in-app notifications.
      </p>

      <h2 style={styles.subHeading}>10. Contact Us</h2>
      <p>
        If you have any questions, contact us at:
        <br />
        <strong>Email:</strong> support@vv-trip.com
        <br />
      </p>

      <p>
        By using VV Trips App, you acknowledge that you have read and understood
        this Privacy Policy.
      </p>
    </div>
  );
};

// Define TypeScript styles
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "bold",
    textAlign: "center",
  },
  date: {
    textAlign: "center",
    fontSize: "14px",
    color: "gray",
  },
  subHeading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "20px",
  },
};

export default PrivacyPolicy;
